module.exports = __webpack_public_path__ + "img/file-earmark-plus-fill.bb5b628a.svg";